export default __webpack_public_path__ + "assets/images/475e5cd1da89f6dd8ed721967b38819f.png";